module.exports = __webpack_public_path__ + "img/imgYLSYB(15).d0751d1e.png";